/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PageHtml5DTO } from '../model/pageHtml5DTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ConfiguratorPublicLandingPageService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getIhmTemplate
     *
     * @param xDataStoreID X-DataStoreID
     * @param codeLandingpage codeLandingpage
     * @param lang lang
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getIhmTemplateUsingGET(xDataStoreID: string, codeLandingpage: string, lang: string, token?: string, observe?: 'body', reportProgress?: boolean): Observable<PageHtml5DTO>;
    public getIhmTemplateUsingGET(xDataStoreID: string, codeLandingpage: string, lang: string, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageHtml5DTO>>;
    public getIhmTemplateUsingGET(xDataStoreID: string, codeLandingpage: string, lang: string, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageHtml5DTO>>;
    public getIhmTemplateUsingGET(xDataStoreID: string, codeLandingpage: string, lang: string, token?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getIhmTemplateUsingGET.');
        }

        if (codeLandingpage === null || codeLandingpage === undefined) {
            throw new Error('Required parameter codeLandingpage was null or undefined when calling getIhmTemplateUsingGET.');
        }

        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling getIhmTemplateUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codeLandingpage !== undefined && codeLandingpage !== null) {
            queryParameters = queryParameters.set('codeLandingpage', <any>codeLandingpage);
        }
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PageHtml5DTO>(`${this.basePath}/api/public/v1/landingpage/ihm/template`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getPageHtml5ByCode
     *
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPageHtml5ByCodeUsingGET(xDataStoreID: string, code: string, observe?: 'body', reportProgress?: boolean): Observable<PageHtml5DTO>;
    public getPageHtml5ByCodeUsingGET(xDataStoreID: string, code: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageHtml5DTO>>;
    public getPageHtml5ByCodeUsingGET(xDataStoreID: string, code: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageHtml5DTO>>;
    public getPageHtml5ByCodeUsingGET(xDataStoreID: string, code: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPageHtml5ByCodeUsingGET.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling getPageHtml5ByCodeUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PageHtml5DTO>(`${this.basePath}/api/public/v1/landingpage/test/ihm/page-html5/${encodeURIComponent(String(code))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
